<template>
    <div class="bbs">
        <a :href="`//bbs.pcauto.com.cn/forum-${bbsInfo.forumId}.html`" target="_blank" class="bbs-title" v-if="$global.tab.title === 'auto_index'" @click="countAd(4193)"><font>{{$global.q}}</font>的论坛</a>
        <div class="bbs-head">
            <div class="cxltArea">
                <div class="left">
                    <a :href="`//bbs.pcauto.com.cn/forum-${bbsInfo.forumId}.html`" target="_blank" @click="pictrueBp"><img :src="bbsInfo.photo || $bbsHeadDefaultImgUrl"></a>
                </div>
                <div class="right">
                    <p class="strong"><a :href="`//bbs.pcauto.com.cn/forum-${bbsInfo.forumId}.html`" target="_blank" @click="titleBp">{{bbsInfo.forumName}}</a><a href="javascript:;" @click="reqCollection" class="shoucang" :class="{'quxiaoshoucang' : shoucangOrno}"></a></p>
                    <p v-if="bbsInfo && bbsInfo.forumAdmin1.length > 0">
                        版主： 
                        <a :href="`//my.pcauto.com.cn/${name.userId}/forum`" target="_blank" v-for="(name,index) in bbsInfo.forumAdmin1" :key="index">{{name.nickname}}</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="index-show" v-if="$global.tab.title === 'auto_index'">
            <ul class="cxltUl">
                <li v-for="(bbs,index) in bbsInfo.topics" :key="index">
                    <a :href="bbs.url" target="_blank" @click="countAd(4198)">{{bbs.title}}
                        <i class="jing" v-if="bbs.isHot"></i>
                        <i class="pic" v-if="bbs.isPhotosNum"></i>
                    </a>
                    <i class="date">{{bbs.date}}</i>
                </li>
            </ul>
            <a :href="`//bbs.pcauto.com.cn/forum-${bbsInfo.forumId}.html`" target="bank" class="more" @click="countAd(4199)">更多帖子&gt;&gt;</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BbsHead',
        props: {
            bbsInfo:{
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                shoucangOrno: false, //是否收藏
                isLogin: false, //用户是否登录
                userId: 0, //用户id
            }
        },
        methods: {
            //点击收藏或者取消收藏
             async reqCollection() {
                this.btnBp()
                if(!this.isLogin) return alert('请先登录')
                const res = await this.fetCollection({
                    userId:this.userId,
                    forumId:this.bbsInfo.forumId
                })
                if( res.isBind === false )  {
                    alert('已取消次模块的收藏')
                    this.shoucangOrno = false
                    this.reqCollectionStatus()
                }
                if( res.isBind === true) {
                    alert('指定的板块已经添加到收藏夹')
                    this.shoucangOrno = true
                    this.reqCollectionStatus()
                }
            },
            //获取用户收藏状态 if 用户登录
             async reqCollectionStatus(id) {
                const res = await this.fetCollectionStatus({
                    userId:id,
                    forumId:this.bbsInfo.forumId
                })
                if(res && res.code === 0) {
                    this.shoucangOrno = res.isBind
                }
            },
            //获取用户登录状态
            async reqUserInfo() {
                try {
                    const res = await this.fetUserInfo()
                    this.reqCollectionStatus(res.id)
                    if(res.id != '0') {
                        this.isLogin = true
                        this.userId = res.id
                    }else {
                        this.isLogin = false
                        this.userId = ''
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            //埋点
            pictrueBp() {
                if(this.$global.tab.title === 'auto_index') {
                    this.countAd(4194)
                }else {
                    this.countAd(4264)
                }
            },
            titleBp() {
                if(this.$global.tab.title === 'auto_index') {
                    this.countAd(4195)
                }else {
                    this.countAd(4531)
                }
            },
            btnBp() {
                if(this.$global.tab.title === 'auto_index') {
                    if(this.shoucangOrno) {
                        this.countAd(4197)
                    }else {
                        this.countAd(4196)
                    }
                }else {
                    if(this.shoucangOrno) {
                        this.countAd(4266)
                    }else {
                        this.countAd(4265)
                    }
                }
            },
        },
        mounted() {
            this.reqUserInfo()
        },
    }
</script>

<style lang="scss" scoped>
.bbs {
    margin-bottom: 25px;
    .bbs-title {
        display: inline-block;
        padding: 10px 0;
        line-height: 16px;
        font-size: 16px;
        color: #225599;
        text-decoration: underline;
        font {
            color: #cc0000;
        }
    }
    .bbs-head {
        width: 618px;
        border: 1px solid #e6e6e6;
        background: #fcfcfc;
        .cxltArea {
            display: flex;
            .left {
                margin: 1px 0 0 1px;
                padding-bottom: 1px;      
                a {
                    img {
                        width: 120px;
                        height: 90px;
                    }
                }      
            }
            .right {
                width: 485px;
                margin-left: 10px;
                .strong {
                    font-size: 14px;
                    font-weight: bold;
                    color: #225599;
                    overflow: hidden;
                    padding: 10px 0;
                    height: 24px;                
                    a {
                        color: #225599;
                        margin-right: 10px;                    
                    }
                    .shoucang {
                        display: inline-block;
                        width: 48px;
                        height: 16px;
                        background-position: 0 -197px;
                        position: relative;
                        top: 3px;   
                        background-image: url($imageURL);        
                        &.quxiaoshoucang {
                            background-position: -57px -197px;
                            width: 57px;
                        }         
                    }
                }
                p {
                    color: #777777;
                    height: 21px;
                    line-height: 21px;
                    overflow: hidden;
                    a {
                        color: #225599;
                        margin-right: 10px;
                    }
                }
            }
        }
    }
    .index-show {
        .cxltUl {
            li {
                line-height: 22px;
                height: 22px;
                background: url(//www1.pcauto.com.cn/2014/kuaisou/images/cxltil.png) 0 10px no-repeat;
                padding-left: 10px;
                clear: both;
                overflow: hidden;
                display: flex;
                justify-content: space-between;
                i {
                    font-style: normal;
                }
                a {
                    text-decoration: underline;
                    color: #225599;
                    float: left;          
                }
                .jing {
                    display: inline-block;
                    width: 15px;
                    height: 15px;
                    margin-left: 5px;
                    vertical-align: middle;
                    background: url($imageURL) no-repeat;             
                    background-position: 0 -213px;   
                }
                .pic {
                    display: inline-block;
                    width: 14px;
                    height: 15px;
                    margin-left: 5px;
                    vertical-align: middle;
                    background: url($imageURL) no-repeat;             
                    background-position: -22px -213px;    
                }
                .date {
                    color: #777777;        
                    margin-right: 5px;        
                }
            }
        }
        .more {
            display: inline-block;
            margin-top: 15px;
            color: #225599;
            text-decoration: underline;
        }
    }
}
</style>